<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";
/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, Footer, },
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null || null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      isMenuCondensed: false,
      showHelp: false,
      imageFile: '',
      page_loader: false,
      loader2: false,
      message: '',
      editorOptions: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }], // Font size
            ["bold", "italic", "underline"], // Formatting buttons
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            ["clean"], // Clear formatting
          ],
        }
      }
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },

    handleImageUpload(event) {
      this.imageFile = event.target.files[0];
    },
  },

  mounted() {
    setTimeout(() => {
      this.page_loader = false; // Hide preloader after 0.1 seconds
    }, 100);
  },
};
</script>

<template>
  <div>

    <div id="layout-wrapper">
      <NavBar />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth"
        style="background-color: black;" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <!-- <transition name="fade"> -->
            <div v-if="page_loader" id="preloader">
              <div id="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
          <!-- </transition> -->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
      </div>
      <!-- <RightBar /> -->
    </div>
  </div>
</template>

